<template>
  <div
    id="arrange"
    ref="anchorBox"
    :style="{ width: `${51.449 * arrangeList_computed.length}vh` }"
    v-if="arrangeList && arrangeList.length != 0"
  >
    <div class="inner-box" v-if="arrangeList_computed.length !== 0">
      <div class="day-title-bg"></div>
      <div
        class="day-box"
        v-for="(arrange, key) in arrangeList_computed"
        :key="key"
      >
        <div class="day-title">
          <i class="icon_1"></i>
          <div class="day">
            <div class="label-box">
              <span class="label-shadow">{{ arrange.day }}</span>
              <span class="label-text">{{ arrange.day }}</span>
            </div>
          </div>
          <div class="week">
            <div class="label-box">
              <span class="label-shadow">{{ arrange.week }}</span>
              <span class="label-text">{{ arrange.week }}</span>
            </div>
          </div>
          <div class="title">
            <div class="label-box">
              <span class="label-shadow">{{ arrange.title }}</span>
              <span class="label-text">{{ arrange.title }}</span>
            </div>
          </div>
          <i class="icon_2"></i>
        </div>
        <div
          class="category-box"
          v-if="arrange.categoryList && arrange.categoryList.length != 0"
        >
          <div class="category-list">
            <div
              class="category"
              v-for="(category, key) in arrange.categoryList"
              :key="key"
              :class="{ anchor: category.status === 3 }"
              @click="showTeams(category)"
            >
              <div class="left-box" :class="{ active: category.status == 2 }">
                <div class="time">{{ category.time }}</div>
                <div class="status">{{ category.status | getStatus }}</div>
              </div>
              <div class="right-box">
                <div class="inner">
                  <div class="top-box">
                    <div class="title">
                      <div class="bg"></div>
                      <div class="label-box">
                        <span class="label-shadow">{{ category.title }}</span>
                        <span class="label-text">{{ category.title }}</span>
                      </div>
                    </div>
                    <ui-frame-bg
                      class="details"
                      colorType="blue"
                      :class="{ hasPoints: category.status != 1 }"
                      @click.native="(e) => showScores(e, category, `${arrange.day} ${arrange.week} ${category.title}`)"
                    >
                      <div class="label-box">
                        <span class="label-shadow">积分详情</span>
                        <span class="label-text">积分详情</span>
                      </div>
                      <i></i>
                    </ui-frame-bg>
                  </div>
                  <ul
                    class="bottom-box"
                    v-if="category.teams && category.teams.length != 0"
                  >
                    <li
                      v-for="i in 3"
                      :key="i"
                      :style="{
                        'background-image': `url(${
                          category.teams[i - 1] 
                            ? category.teams[i - 1]?.avatar || defaultAvatar
                            : defaultAvatar
                        })`,
                      }"
                    ></li>
                    <li name="4"></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Interdict v-else tip="暂无赛程" hook="vh" />
  </div>
</template>

<script>
import UiFrameBg from '@/components/ui-frame-bg';
import Interdict from '@/components/interdict';

export default {
  components: { UiFrameBg, Interdict },
  data() {
    return {
      // arrangeList: [],
      subPhase: "",
      phaseID: "",

      defaultAvatar: "https://website.xdcdn.net/poster/sausage/match/zhanduilogo/z51MQgVN.png"
    };
  },
  props: {
    scoreModal: {
      type: Function,
      default: () => {},
    },
    teamsModal: {
      type: Function,
      default: () => {},
    },
    arrangeList: {
      type: Array,
      default: () => [],
    },
    handleAnchor: {
      type: Function,
      default: () => {},
    },
  },
  watch: {
    arrangeList() {
      this.$nextTick(() => {
        let $anchorBox = this.$refs.anchorBox,
          $anchors = document.getElementsByClassName("anchor");
        if ($anchors && $anchors.length != 0) {
          let $end = $anchors[$anchors.length - 1];
          let offsetLeft = $end.offsetLeft - $anchorBox.offsetLeft;
          this.handleAnchor(offsetLeft);
        }
      });
    },
  },
  filters: {
    getStatus: (value) => {
      let subStatus = "";
      switch (Number(value)) {
        case 1:
          subStatus = "未开始";
          break;
        case 2:
          subStatus = "进行中";
          break;
        case 3:
          subStatus = "已结束";
          break;
      }

      return subStatus;
    },
    getDetailsText: (category) => {
      let text = "";
      if (category && category.status != 1) {
        text = "积分详情";
      } else {
        text = "参赛战队";
      }

      return text;
    },
  },
  computed: {
    arrangeList_computed() {
      let list = [];
      if (this.arrangeList && this.arrangeList.length != 0) {
        if (this.phaseID != "" && this.phaseID != "all") {
          list = this.arrangeList.filter(
            (item) => item.categoryId == this.phaseID
          );
        } else {
          list = this.arrangeList;
        }
      }

      return list;
    },
  },
  methods: {
    showTeams(category) {
      // 参赛战队
      this.teamsModal(category.teams ? category.teams : []);

      // 埋点
      if(typeof tapdb == 'undefined') return;
      tapdb.trackEvent('查看队伍', {
        '#schedule_id': category.title
      });
    },
    showScores(e, category, title) {
      e.stopPropagation();

      // 积分详情
      this.scoreModal(category.scheduleCode, title);

      // 埋点
      if(typeof tapdb == 'undefined') return;
      tapdb.trackEvent('查看对局', {
        '#schedule_id': category.title,
        "#match_id": '总积分'
      });
    },
    switchPhase(phaseID) {
      this.phaseID = phaseID;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/schedule/arrange";
</style>